import createClient from 'openapi-fetch';
import type { paths } from '@/api/api-types';
import { useParentAuthStore } from '@/store/auth';

export const useApiClient = () => {
  const authStore = useParentAuthStore();
 
  const client = createClient<paths>({
    baseUrl: `${import.meta.env.VITE_API_BASE_URL}/api/${
      import.meta.env.VITE_API_VERSION
    }/`,
  });

  const getHeaders = () => ({
    Authorization: `Bearer ${authStore.state.access_token}`,
  });

  return {
    GET: (url: any, options?: any) => 
      client.GET(url, { 
        ...options, 
        headers: { ...getHeaders(), ...options?.headers } 
      }),
    
    POST: (url: any, options?: any) => 
      client.POST(url, { 
        ...options, 
        headers: { ...getHeaders(), ...options?.headers } 
      }),
    
    PATCH: (url: any, options?: any) => 
      client.PATCH(url, { 
        ...options, 
        headers: { ...getHeaders(), ...options?.headers } 
      }),
    
    
    DELETE: (url: any, options?: any) => 
      client.DELETE(url, { 
        ...options, 
        headers: { ...getHeaders(), ...options?.headers } 
      }),
  };
};